import React, { useEffect } from 'react';
import { Tooltip } from 'react-tooltip';
import './Chatbot.css';

const Chatbot: React.FC = () => {
  useEffect(() => {
    if (!document.querySelector('link[href="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/themes/df-messenger-default.css"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/themes/df-messenger-default.css';
      document.head.appendChild(link);
    }

    if (!document.querySelector('script[src="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <>
      <div className="chatbot-container">
        <df-messenger
          location="europe-west2"
          project-id="dev-finwise-fin-data"
          agent-id="2f3ba9f0-ac82-4ee1-9e8a-f7e12f343546"
          language-code="en"
          max-query-length="-1"
          intent="WELCOME"
                      data-tooltip-id="chatbot-tooltip"
            data-tooltip-content="Apollo AI Assistant (Beta)"
          >
          
          <df-messenger-chat-bubble

            chat-title="Apollo AI Assistant (Beta)"
            chat-icon="https://storage.cloud.google.com/finwisewql/apollo_ai_logo.png"
            chat-title-icon="https://storage.cloud.google.com/finwisewql/apollo_ai_logo.png">
          </df-messenger-chat-bubble>
        </df-messenger>
      </div>
      <Tooltip id="chatbot-tooltip" />
    </>
  );
};

export default Chatbot;